@if (application(); as application) {
  <div class="application-details">
    <div class='row'>
      <div class='col-md-3'>
        <app-label label='Data utworzenia:'>
          {{ application?.createdAt | date }}
        </app-label>
      </div>
      <div class='col-md-3'>
        <app-label label='Data zatwierdzenia:'>
          {{ application?.updatedAt | date }}
        </app-label>
      </div>
      <div class='col-md-6'>
        <app-label label='Numer sprawy:'>
          {{ application?.caseNumber || '-' }}
        </app-label>
      </div>
    </div>
    <ng-container *ngIf='shipments()?.length'>
      <br>
      <app-decision-data-preview [canPay]="canPay()" [shipments]="shipments()">
      </app-decision-data-preview>
      <br>
    </ng-container>
    <app-applicant-preview
      [application]="application"
      [expanded]="expanded">
    </app-applicant-preview>
    <br>
    <h3>
      Dane wniosku
    </h3>
    <app-application-data-preview [application]="application">
    </app-application-data-preview>
    <br>
    <h3>
      Zdarzenie
    </h3>
    <div class="row">
      <div class="col-12">
        <app-label label="Przyczyna zdarzenia:">
          {{ application?.description || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Miejscowość:">
          {{ application?.city }}
        </app-label>
      </div>
      <div class="col-md-4">
        <app-label label="Numer drogi:">
          {{ application?.roadNumber || '-' }}
        </app-label>
      </div>
      <div class="col-md-8">
        <app-label label="Nazwa drogi:">
          {{ application?.roadName }}
        </app-label>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-md-3">
        <app-label label="Data zdarzenia:">
          {{ application?.eventStartDate | date }}
        </app-label>
      </div>
      <div class="col-md-3">
        <app-label label="Czas zdarzenia:">
          {{ application?.eventStartTime }}
        </app-label>
      </div>
      <div class="col-md-4">
        <app-label label="Szacowana wartość szkód:">
          {{ application?.estimatedDamageValue | currency }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Miejsce zdarzenia:">
          {{ application?.eventLocation || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Opis uszkodzeń:">
          {{ application?.eventDescription || '-' }}
        </app-label>
      </div>
    </div>
    <br>
    <p class="mb-2">
      <strong>Dane poszkodowanego</strong>
    </p>
    <div class="row">
      @if (application?.injuredDataSameAsApplicant) {
        <div class="col-12">
          <app-label label="Dane adresowe poszkodowanego:">
            Dane adresowe poszkodowanego takie same jak dane wnioskodawcy
          </app-label>
        </div>
      } @else {
        <div class="col-md-4">
          <app-label label="Imię/Imiona:">
            {{ application?.correspondenceFirstName || '-' }}
          </app-label>
        </div>
        <div class="col-md-4">
          <app-label label="Nazwisko:">
            {{ application?.correspondenceLastName || '-' }}
          </app-label>
        </div>
        <div class="col-md-4">
          <app-label label="Numer telefonu:">
            {{ application?.correspondencePhone || '-' }}
          </app-label>
        </div>
        <div class="col-md-4">
          <app-label label="E-mail:">
            {{ application?.correspondenceEmail || '-' }}
          </app-label>
        </div>
        <div class="col-md-4">
          <app-label label="Kod pocztowy:">
            {{ application?.correspondencePostalCode || '-' }}
          </app-label>
        </div>
        <div class="col-md-4">
          <app-label label="Poczta:">
            {{ application?.correspondencePostOffice || '-' }}
          </app-label>
        </div>
        <div class="col-md-4">
          <app-label label="Miejscowość:">
            {{ application?.correspondenceCity || '-' }}
          </app-label>
        </div>
        <div class="col-md-4">
          <app-label label="Ulica:">
            {{ application?.correspondenceStreet || '-' }}
          </app-label>
        </div>
        <div class="col-md-2">
          <app-label label="Nr. domu:">
            {{ application?.correspondenceHouseNumber || '-' }}
          </app-label>
        </div>
        <div class="col-md-2">
          <app-label label="Nr. mieszkania:">
            {{ application?.correspondenceApartmentNumber || '-' }}
          </app-label>
        </div>
      }
    </div>
    <div class="row">
      <div class="col-md-4">
        <app-label label="Rodzaj szkody:">
          {{ application?.damageType || '-' }}
        </app-label>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <app-label label="Służby powiadomione o zdarzeniu:">
          {{ application?.servicesNotifiedAboutEventDesc || application?.servicesNotifiedAboutEvent || '-' }}
        </app-label>
      </div>
    </div>
    <br>
    <p class="mb-2">
      <strong>Informacje końcowe</strong>
    </p>
    <div class="row">
      <div class="col-12">
        <app-label label="Informacje dodatkowe:">
          {{ application?.additionalInformation || '-' }}
        </app-label>
      </div>
    </div>
    <br>
    <h3>
      Zgody
    </h3>
    <app-agreements-data-preview [application]="application">
    </app-agreements-data-preview>
    <br>
    <h3>
      Załączniki
    </h3>
    <app-attachments-data-preview [application]="application">
    </app-attachments-data-preview>
  </div>
}
